import { render, staticRenderFns } from "./OmitirEnCuentaCorriente.vue?vue&type=template&id=72caaa7e&"
import script from "./OmitirEnCuentaCorriente.vue?vue&type=script&lang=js&"
export * from "./OmitirEnCuentaCorriente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports